// extracted by mini-css-extract-plugin
module.exports = {"password-auth":"PasswordConfiguration_password-auth__uiIGU"};